import { io } from 'socket.io-client';

const API = import.meta.env.VITE_API_URL || 'https://funnytask.net/api';
const SOCKET_URL = API.replace(/\/api\/?$/, '');

let socket = null;
let presenceWired = false;

// Tab có đang được XEM không = hiển thị (không ẩn/minimize) và đang focus.
function isViewing() {
  return document.visibilityState === 'visible' && document.hasFocus();
}
function emitPresence() {
  if (socket && socket.connected) socket.emit('presence:active', isViewing());
}
// Nếu có socket mà đang RỚT -> nối lại NGAY (không chờ backoff). Dùng khi app quay lại foreground
// / tab hiện lại / định kỳ soi — WebView Android hay treo socket khi ở nền, mở lại phải nối liền.
function ensureConnected() {
  if (socket && !socket.connected) { try { socket.connect(); } catch { /* bỏ qua */ } }
  emitPresence();
}

// Gắn listener 1 lần: đổi focus/hiển thị -> báo server + ĐẢM BẢO socket còn sống (nối lại nếu rớt).
function wirePresence() {
  if (presenceWired) return;
  presenceWired = true;
  window.addEventListener('focus', ensureConnected, { passive: true });
  window.addEventListener('blur', emitPresence, { passive: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) ensureConnected(); else emitPresence(); }, { passive: true });
  // App NATIVE: khi trở lại foreground (Android đưa nền hay treo WebView+socket) -> nối lại tức thì.
  if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) {
    import('@capacitor/app').then(({ App }) => {
      App.addListener('resume', ensureConnected);
      App.addListener('appStateChange', ({ isActive }) => { if (isActive) ensureConnected(); });
    }).catch(() => {});
  }
  // Lưới an toàn: cứ 10s soi, socket rớt thì nối lại (phòng reconnect tự động của socket.io bỏ cuộc).
  setInterval(() => { if (socket && !socket.connected) ensureConnected(); }, 10000);
}

export function connectSocket() {
  const token = localStorage.getItem('ft_token');
  if (!token) return null;
  if (socket && socket.connected) return socket;
  if (socket) { socket.connect(); return socket; }
  // App NATIVE (Capacitor iOS/Android): WebView Android hay LỖI/CHẬM mở WebSocket thẳng -> socket treo,
  // tin về trễ + không realtime. Dùng thứ tự CHUẨN của socket.io: POLLING trước (kết nối ngay, chạy
  // mọi WebView, long-poll giao tin gần tức thì) rồi TỰ NÂNG lên WebSocket. Web trình duyệt giữ
  // websocket-trước (đã chạy tốt). => Android nhận tin tức thì thay vì tụt fallback.
  const isNative = typeof window !== 'undefined' && !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  socket = io(SOCKET_URL, {
    auth: { token },
    transports: isNative ? ['polling', 'websocket'] : ['websocket', 'polling'],
    upgrade: true, // vẫn nâng lên websocket khi được (nhanh hơn) — không được thì ở lại polling
    // Kết nối lại NHANH sau khi mạng chập chờn (mặc định tới ~5s mới thử lại -> khoảng trống dễ miss tin).
    reconnectionDelay: 400,
    reconnectionDelayMax: 2500,
    timeout: 8000,
  });
  socket.on('connect', () => {
    emitPresence(); // báo trạng thái ngay khi (tái) kết nối
    // CHẨN ĐOÁN "tin sau chậm": soi transport. Nếu sau vài giây VẪN là 'polling' = KẸT polling
    // (thường do nginx prod chưa proxy websocket-upgrade cho /socket.io/) -> tin sau chờ khe hở poll.
    // Nếu lên 'websocket' = tốt, tin về tức thì.
    try { console.log('[socket] connect — transport:', socket.io.engine.transport.name); } catch { /* */ }
    setTimeout(() => { try { console.log('[socket] transport sau 3s:', socket.io.engine.transport.name); } catch { /* */ } }, 3000);
  });
  try { socket.io.engine?.on?.('upgrade', (t) => console.log('[socket] ⬆ nâng transport ->', t.name)); } catch { /* */ }
  wirePresence();
  return socket;
}

export function getSocket() {
  return socket;
}

// Báo "đang gõ" tới các thành viên khác của hội thoại (client tự gửi kèm danh sách người nhận).
export function emitTyping(convId, to, typing) {
  if (socket && socket.connected) socket.emit('chat:typing', { convId, to, typing });
}

// BUZZ! — rung chuông gọi thành viên hội thoại (client gửi kèm danh sách người nhận `to`).
export function emitBuzz(convId, to) {
  if (socket && socket.connected) socket.emit('chat:buzz', { convId, to });
}

// Chat KH: vào/rời "phòng" hội thoại đang mở (để nhận "đang gõ" của NV khác).
export function emitCustView(convId) {
  if (socket && socket.connected) socket.emit('custchat:view', { convId: convId || null });
}
// Chat KH: báo "đang gõ" cho các NV khác đang mở cùng hội thoại.
export function emitCustTyping(convId, typing) {
  if (socket && socket.connected) socket.emit('custchat:typing', { convId, typing });
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
